import React from 'react';
import {Stack} from '@mui/material';
import {Body, Button, Icon} from '@lightricks/react-design-system';
import translate from '@/utils/translate';
import useDashboardUserQuery from '@/hooks/queries/use-dashboard-user-query';
import useCopyToClipboardWithFeedback from '@/hooks/useCopyToClipboardWithFeedback';

type CreatorEmailCopyProps = {
  email?: string | null;
  testID?: string;
  className?: string;
};

function CreatorEmailCopy({
  email,
  testID = 'creator-email-copy',
  className,
}: CreatorEmailCopyProps) {
  const {dashboardUser} = useDashboardUserQuery({});
  const isAdmin = Boolean(dashboardUser.hasPlatformAdminRole);
  const {copied, copyToClipboard} = useCopyToClipboardWithFeedback();

  if (!isAdmin || !email) {
    return null;
  }

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap="4px"
      className={className}
      sx={{minWidth: 0, maxWidth: '100%'}}
    >
      <Body size="sm" noWrap sx={{minWidth: 0}} data-testid={`${testID}-email`}>
        {email}
      </Body>
      <Button
        testID={`${testID}-copy-email`}
        sx={{flexShrink: 0}}
        size="small"
        appearance="neutral"
        mode="plain"
        onClick={() => copyToClipboard(email)}
        aria-label={translate('Copy email')}
        icon={
          <Icon
            size="small"
            appearance="neutral"
            name={copied ? 'Features-Check' : 'Navigation-Copy'}
          />
        }
      />
    </Stack>
  );
}

export default CreatorEmailCopy;
